<template>
  <div>
    <div v-if="!stateRef.contentLoaded" class="preloadFilter">
      <Loading />
    </div>
    <form
      v-if="stateRef.contentLoaded && !config.worldwide && stateRef.data.zip"
      @submit.prevent="handleSubmit"
    >
      <div :class="[$style.filter, 'columns', { ['is-mobile']: isMobile }]">
        <div class="column">
          <FormInput
            v-model="stateRef.zipValue"
            aria-label="enter zip"
            :error="!isZip && stateRef.zipValue !== null && stateRef.zipValue !== ''"
            :error-message="stateRef.data.zip.errorMessage"
            :placeholder="stateRef.data.zip.placeholderText"
            @input="zipActive = false"
          />
        </div>
        <div class="column">
          <Button1XP :is-disabled="!isZip" size="s" start-icon="search" @click="handleSubmit" />
        </div>
      </div>
    </form>
    <div
      v-if="stateRef.contentLoaded && !config.worldwide && stateRef.data.zip && zipActive"
      :class="$style.zipResultText"
      v-html="
        stateRef.data.zip.resultMessage.replace(/\{.*?\}/g, `<strong>${stateRef.zipValue}</strong>`)
      "
    />
    <div
      v-if="
        stateRef.contentLoaded &&
        !config.worldwide &&
        stateRef.data.group &&
        stateRef.data.group.useFilter
      "
      :class="[$style.filter, $style.groupFilter]"
    >
      <FormSelect
        v-model="stateRef.filter.initialSelectOption"
        :colour="stateRef.filter.colour"
        :has-filter="false"
        :initial-option="stateRef.filter.initialSelectOption"
        :options="stateRef.selectOptions"
        @update="updateFilter"
      />
    </div>
    <div v-if="stateRef.activeTab === tab && stateRef.data.zip">
      <div v-for="(range, ind) in stateRef.content" :key="ind">
        <div
          v-if="
            zipActive &&
            isZip &&
            stateRef.zipValue >= range.from &&
            stateRef.zipValue <= range.to &&
            range.departments &&
            range.departments.length === 0
          "
          :class="['columns', 'is-variable', 'is-multiline', { ['is-mobile']: isMobile }]"
        >
          <div class="column is-full">
            <br />
          </div>
          <template v-for="(contact, index) in range.contacts" :key="index">
            <div
              :class="[
                { [$style.mobileColumn]: isMobile },
                'column',
                { ['is-half-mobile']: isMobile },
                { ['is-half-tablet']: !isMobile },
                { ['is-one-quarter-desktop']: !isMobile },
              ]"
            >
              <ContactBox
                :id="contact.id"
                :address="contact.address"
                :company="contact.company"
                :email="contact.email"
                :fax="contact.fax"
                :firstname="contact.firstname"
                :form-email="contact.formEmail"
                :image="contact.image"
                :lastname="contact.lastname"
                :mobile="contact.mobile"
                :phone="contact.phone"
                :position="contact.position"
                :use-form="config.useForm"
                :vcard="contact.vcard"
                :website="contact.website"
                :website-text="contact.website_text"
              />
            </div>
          </template>
        </div>
        <div
          v-if="
            zipActive &&
            isZip &&
            stateRef.zipValue >= range.from &&
            stateRef.zipValue <= range.to &&
            range.departments &&
            range.departments.length !== 0
          "
          :class="['columns', 'is-variable', 'is-multiline', { ['is-mobile']: isMobile }]"
        >
          <h2 :class="[$style.subHeadline, 'column is-full']">
            <hr />
            {{ range.departments[0] }}
          </h2>
          <template v-for="(contact, index) in range.contacts">
            <div
              v-if="contact.departments[0] === range.departments[0]"
              :key="index"
              :class="[
                { [$style.mobileColumn]: isMobile },
                'column',
                { ['is-half-mobile']: isMobile },
                { ['is-half-tablet']: !isMobile },
                { ['is-one-quarter-desktop']: !isMobile },
              ]"
            >
              <ContactBox
                :id="contact.id"
                :address="contact.address"
                :company="contact.company"
                :email="contact.email"
                :fax="contact.fax"
                :firstname="contact.firstname"
                :form-email="contact.formEmail"
                :image="contact.image"
                :lastname="contact.lastname"
                :mobile="contact.mobile"
                :phone="contact.phone"
                :position="contact.position"
                :use-form="config.useForm"
                :vcard="contact.vcard"
                :website="contact.website"
                :website-text="contact.website_text"
              />
            </div>
          </template>
        </div>
        <div
          v-if="
            zipActive &&
            isZip &&
            stateRef.zipValue >= range.from &&
            stateRef.zipValue <= range.to &&
            range.departments &&
            range.departments.length !== 0
          "
          :class="['columns', 'is-variable', 'is-multiline', { ['is-mobile']: isMobile }]"
        >
          <h2 :class="[$style.subHeadline, 'column is-full']">
            <hr />
            {{ range.departments[1] }}
          </h2>
          <template v-for="(contact, index) in range.contacts">
            <div
              v-if="contact.departments[0] === range.departments[1]"
              :key="index"
              :class="[
                { [$style.mobileColumn]: isMobile },
                'column',
                { ['is-half-mobile']: isMobile },
                { ['is-half-tablet']: !isMobile },
                { ['is-one-quarter-desktop']: !isMobile },
              ]"
            >
              <ContactBox
                :id="contact.id"
                :address="contact.address"
                :company="contact.company"
                :email="contact.email"
                :fax="contact.fax"
                :firstname="contact.firstname"
                :form-email="contact.formEmail"
                :image="contact.image"
                :lastname="contact.lastname"
                :mobile="contact.mobile"
                :phone="contact.phone"
                :position="contact.position"
                :use-form="config.useForm"
                :vcard="contact.vcard"
                :website="contact.website"
                :website-text="contact.website_text"
              />
            </div>
          </template>
        </div>
      </div>
    </div>
    <div v-if="stateRef.activeTab === tab && stateRef.data.group && stateRef.data.group.useFilter">
      <div
        v-for="(group, ind) in stateRef.content"
        :key="ind"
        :ref="(el) => (formRefs[ind] = [group.name, el])"
        :class="[$style.group, 'columns is-variable is-multiline', { ['is-mobile']: isMobile }]"
      >
        <template v-if="group.contacts && group.contacts.length > 0">
          <div
            v-for="(contact, contactIndex) in group.contacts"
            :key="`${ind}-${contactIndex}`"
            :class="[
              { [$style.mobileColumn]: isMobile },
              'column',
              { ['is-half-mobile']: isMobile },
              { ['is-half-tablet']: !isMobile },
              { ['is-one-quarter-desktop']: !isMobile },
            ]"
          >
            <ContactBox
              :id="contact.id"
              :address="contact.address"
              :company="contact.company"
              :email="contact.email"
              :fax="contact.fax"
              :firstname="contact.firstname"
              :form-email="contact.formEmail"
              :image="contact.image"
              :lastname="contact.lastname"
              :mobile="contact.mobile"
              :phone="contact.phone"
              :position="contact.position"
              :use-form="config.useForm"
              :vcard="contact.vcard"
              :website="contact.website"
              :website-text="contact.website_text"
            />
          </div>
        </template>
        <template v-for="(department, departmentIndex) in group.departments">
          <h2
            v-if="stateRef.data.group.splitByGroups"
            :key="`${ind}-${departmentIndex}`"
            :class="[$style.subHeadline, 'column is-full']"
          >
            <hr />
            {{ department.name }}
          </h2>
          <div
            v-for="(contact, contactIndex) in department.contacts"
            :key="`${ind}-${departmentIndex}-${contactIndex}`"
            :class="[
              { [$style.mobileColumn]: isMobile },
              'column',
              { ['is-half-mobile']: isMobile },
              { ['is-half-tablet']: !isMobile },
              { ['is-one-quarter-desktop']: !isMobile },
            ]"
          >
            <ContactBox
              :id="contact.id"
              :address="contact.address"
              :company="contact.company"
              :email="contact.email"
              :fax="contact.fax"
              :firstname="contact.firstname"
              :form-email="contact.formEmail"
              :image="contact.image"
              :lastname="contact.lastname"
              :mobile="contact.mobile"
              :phone="contact.phone"
              :position="contact.position"
              :use-form="config.useForm"
              :vcard="contact.vcard"
              :website="contact.website"
              :website-text="contact.website_text"
            />
          </div>
        </template>
      </div>
    </div>
    <div v-if="stateRef.activeTab === tab && stateRef.data.group && !stateRef.data.group.useFilter">
      <div
        :class="[
          $style.group,
          $style.active,
          'columns is-variable is-multiline',
          { ['is-mobile']: isMobile },
        ]"
      >
        <template v-for="(group, ind) in stateRef.content">
          <h2
            v-if="stateRef.data.group.splitByGroups"
            :key="ind"
            :class="[$style.subHeadline, 'column is-full']"
          >
            <hr />
            {{ group.name }}
          </h2>
          <div
            v-for="(contact, index) in group.contacts"
            :key="`${ind}-${index}`"
            :class="[
              { [$style.mobileColumn]: isMobile },
              'column',
              { ['is-half-mobile']: isMobile },
              { ['is-half-tablet']: !isMobile },
              { ['is-one-quarter-desktop']: !isMobile },
            ]"
          >
            <ContactBox
              :id="contact.id"
              :address="contact.address"
              :company="contact.company"
              :email="contact.email"
              :fax="contact.fax"
              :firstname="contact.firstname"
              :form-email="contact.formEmail"
              :image="contact.image"
              :lastname="contact.lastname"
              :mobile="contact.mobile"
              :phone="contact.phone"
              :position="contact.position"
              :use-form="config.useForm"
              :vcard="contact.vcard"
              :website="contact.website"
              :website-text="contact.website_text"
            />
          </div>
        </template>
      </div>
    </div>
    <div
      v-if="stateRef.activeTab === tab && stateRef.data.contact"
      :class="['columns is-variable is-multiline', { ['is-mobile']: isMobile }]"
    >
      <div
        v-for="(contact, index) in stateRef.content"
        :key="index"
        :class="[
          { [$style.mobileColumn]: isMobile },
          'column',
          { ['is-half-mobile']: isMobile },
          { ['is-half-tablet']: !isMobile },
          { ['is-one-quarter-desktop']: !isMobile },
        ]"
      >
        <ContactBox
          :id="contact.id"
          :address="contact.address"
          :company="contact.company"
          :email="contact.email"
          :fax="contact.fax"
          :firstname="contact.firstname"
          :form-email="contact.formEmail"
          :image="contact.image"
          :lastname="contact.lastname"
          :mobile="contact.mobile"
          :phone="contact.phone"
          :position="contact.position"
          :use-form="config.useForm"
          :vcard="contact.vcard"
          :website="contact.website"
          :website-text="contact.website_text"
        />
      </div>
    </div>
    <div v-if="stateRef.activeTab === tab && config.worldwide">
      <WorldWideList :config="worldwideConfigFromProp" :use-form="config.useForm" />
    </div>
  </div>
</template>

<script setup>
import FormSelect from '../FormSelect/FormSelect.vue';
import FormInput from '../FormInput/FormInput.vue';
import Button1XP from '../Button1XP/Button1XP.vue';
import ContactBox from '../ContactBox/ContactBox.vue';
import WorldWideList from '../WorldWideList/WorldWideList.vue';
import Loading from '../Loading/Loading.vue';
import { onMounted, ref, watch } from 'vue';
import { isMobile } from '../../utils/breakpoints';

const props = defineProps({
  config: {
    type: Object,
    default: () => {},
  },
  state: {
    type: Object,
    default: () => {},
  },
  worldwideConfig: {
    type: Object,
    default: () => {},
  },
  tab: {
    type: Number,
    default: 0,
  },
});

const stateRef = ref(props.state);
const worldwideConfigFromProp = ref(props.worldwideConfig);

const zipActive = ref(false);
const isZip = ref(false);

const wtTrack = window.wtTrack;
const formRefs = ref([]);

const handleSubmit = () => {
  wtTrack({ cat: 'SALESBOXCLICK' }, { inputIdent: stateRef.value.zipValue });
  zipActive.value = isZip.value || false;
};

watch(
  () => props.state,
  (newValue, oldValue) => {
    if (newValue !== oldValue) {
      stateRef.value = newValue;
    }
  },
);

watch(
  () => props.worldwideConfig,
  (newValue, oldValue) => {
    if (newValue !== oldValue) {
      worldwideConfigFromProp.value = newValue;
    }
  },
);

watch(
  () => stateRef.value.zipValue,
  () => {
    isZip.value = new RegExp(stateRef.value.data.zip.regex).test(stateRef.value.zipValue);
  },
);

const updateFilter = (values) => {
  const [value] = values;

  wtTrack({ cat: 'SALESBOXCLICK' }, { inputIdent: value });

  for (let ref in formRefs.value) {
    const [refValue, element] = formRefs.value[ref];

    if (!element) {
      return;
    }

    const { classList } = element;

    if (value === refValue) {
      classList.remove('ContactList__inactive');
      classList.add('ContactList__active');
    } else {
      classList.remove('ContactList__active');
      classList.add('ContactList__inactive');
    }
  }
};

onMounted(() => {
  if (stateRef.value.data.zip && stateRef.value.zipValue) {
    isZip.value = new RegExp(stateRef.value.data.zip.regex).test(stateRef.value.zipValue);
    handleSubmit();
  }
});
</script>

<style module lang="scss">
@forward './ContactList.scss';
</style>
